import { HTMLAttributes, useEffect, useState } from 'react';
import { MdTimer } from 'react-icons/md';

import { getTime } from 'date-fns';
import { twMerge } from 'tailwind-merge';

import { FontSize, FontWeight } from 'commons';
import { Text } from 'components';
import { formatMillisecondsToHours } from 'helpers';

import * as S from './styles';

const DEFAULT_TIMER_FORMAT = '--:--:--';

interface Props extends HTMLAttributes<HTMLDivElement> {
  endTimer: Date;
}

export function Timer({ endTimer, className, ...rest }: Props) {
  const [formattedTimer, setFormattedTimer] = useState(DEFAULT_TIMER_FORMAT);

  useEffect(() => {
    function calculateTimeLeft(timestampDate: Date): number {
      const dateTimestamp = getTime(timestampDate);
      const timestampNow = Date.now();

      return dateTimestamp - timestampNow;
    }

    function setNewTimer() {
      const timeLeft = calculateTimeLeft(endTimer);

      if (timeLeft <= 0) {
        setFormattedTimer(DEFAULT_TIMER_FORMAT);
        return;
      }

      const { hours, minutes, seconds } = formatMillisecondsToHours(timeLeft);
      const newFormattedTimer = `${hours}:${minutes}:${seconds}`;

      setFormattedTimer(newFormattedTimer);
    }

    setNewTimer();

    const intervalId = setInterval(() => {
      setNewTimer();
    }, 1000);

    return () => clearTimeout(intervalId);
  }, [endTimer]);

  return (
    <S.Main className={twMerge('text-neutral-500', className)} {...rest}>
      <S.Icon>
        <MdTimer />
      </S.Icon>

      <Text size={FontSize.font16} weight={FontWeight.bold}>
        {formattedTimer}
      </Text>
    </S.Main>
  );
}
